import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Zap, Users, Layers } from "lucide-react";

const features = [
  {
    title: "Secure & Scalable",
    icon: <ShieldCheck size={36} className="text-green-500" />,
    description:
      "We deliver secure, enterprise-grade applications built to scale with your growth.",
  },
  {
    title: "Fast Delivery",
    icon: <Zap size={36} className="text-green-500" />, // ✅ Correct

    description:
      "Our agile process ensures rapid development cycles and on-time launches.",
  },
  {
    title: "Team Expertise",
    icon: <Users size={36} className="text-green-500" />,
    description:
      "Top-tier designers and developers collaborate to bring your vision to life.",
  },
  {
    title: "Custom Solutions",
    icon: <Layers size={36} className="text-green-500" />,
    description:
      "Tailor-made solutions that align perfectly with your business goals.",
  },
];

const FeatureSection = () => {
  return (
    <section
      className="bg-white py-16 px-6 md:px-12 max-w-7xl mx-auto"
      id="features"
    >
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          Why Choose Mosaic Tech
        </h2>
        <p className="text-gray-600 text-lg">
          We combine innovation, speed, and precision to deliver high-impact
          tech solutions.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="bg-gray-100 rounded-xl p-6 shadow hover:shadow-lg transition"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <div className="mb-4">{feature.icon}</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {feature.title}
            </h3>
            <p className="text-gray-600">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default FeatureSection;
